import { create } from 'zustand';

export interface CouponInfo {
  value: string;
  success: boolean;
}

interface CouponStore {
  couponInfo: CouponInfo | null;
  setCouponInfo: (info: CouponInfo) => void;
}

export const useCouponStore = create<CouponStore>((set) => ({
  couponInfo: null,
  setCouponInfo: (info) => set({ couponInfo: info }),
}));
